import type { FaireProductEntity } from "../../entity_types/product";

export const p_5fxc2jfru6: FaireProductEntity = {
  token: "p_5fxc2jfru6",
  type: "product",
  name: "LM-SP-1000 Sherpa - Black/White",
  brandToken: "b_h6l667zq",
  brandName: "Girlie Girl Originals",
  imageUrl: "https://cdn.faire.com/fastly/c48431badc8e3604031064be80ae8423be4c179a1b5450c68faabe1a790da08c.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/aa8e1bf2e58e78bc4f2aafa9012c533ba45dd2a74eaff55e6715b447c9882fac.jpeg"
  ],
  priceDollars: 39.5,
  description: "This Sherpa-lined graphic sweatshirt from Girlie Girl Originals combines cozy warmth with casual style, featuring a bold black-and-white design. Thoughtfully crafted for comfort and easy layering, it’s an inviting choice for outings, errands, or lounging at home.",
  tags: [],
  msrpDollars: 79,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-28T21:01:48.072Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
